import * as React from "react";
import styled from "../../../styled/index";
import { CS } from "../../../styles/index";
export const Box = styled("div") `
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
  padding: 45px 30px;
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    max-width: 500px;
    margin: 0 auto;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    max-width: 420px;
    margin: 0 auto;
  }
`;
const IconWrapper = styled("div") `
  text-align: center;
  margin-bottom: 25px;
`;
const IconContent = styled("div") `
  ${CS.shadow.light.two};
  ${CS.flex.center};
  margin: 0 auto;
  border-radius: 30px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary_text};
  width: 50px;
  height: 50px;
  font-size: 20px;
`;
export const CircleIcon = (props) => (React.createElement(IconWrapper, null,
    React.createElement(IconContent, null, props.icon)));
//# sourceMappingURL=index.js.map